import { classNames, h } from "omi";

import { COMMUNITY_LINK } from "@/globals/links.ts";

import { DocumentThemeDef } from "../models.ts";
import { DocumentPageProps } from "./models.ts";

export const EndPage = (props: DocumentPageProps) => {
  const themeDef = DocumentThemeDef[props.theme];

  return (
    <div
      class={classNames(
        "w-full max-w-screen-sm flex flex-col mx-auto justify-between py-12 end-page overflow-y-hidden",
        themeDef.background,
      )}
    >
      <div class="w-full items-start">
        <div class="flex items-center justify-between">
          <img src={themeDef.logo} alt="" width="56" height="56" />
          <a href={COMMUNITY_LINK} target="_blank" class={classNames("underline text-xl", themeDef.font)}>
            nextwork.org
          </a>
        </div>
      </div>

      <div class="flex items-center justify-start mb-20 mt-32">
        <div class="w-fit space-y-4">
          <h1 class={classNames("font-medium text-6xl -tracking-wide", themeDef.font)}>
            The place to learn & showcase your skills
          </h1>
          <p class={classNames("text-2xl", themeDef.font)}>
            Check out{" "}
            <a href={COMMUNITY_LINK} target="_blank" class="underline">
              nextwork.org
            </a>{" "}
            for more projects
          </p>
        </div>
      </div>

      <div class="">
        <div class="bg-[url('/static/cover-img.jpeg')] mx-auto bg-cover bg-center w-full h-[540px] rounded-[48px]"></div>
      </div>
    </div>
  );
};
